import { render, staticRenderFns } from "./ExpohallarielBirdView.vue?vue&type=template&id=6de8c3b6&scoped=true"
import script from "./ExpohallarielBirdView.vue?vue&type=script&lang=js"
export * from "./ExpohallarielBirdView.vue?vue&type=script&lang=js"
import style0 from "./ExpohallarielBirdView.vue?vue&type=style&index=0&id=6de8c3b6&prod&scope=true&lang=css"
import style1 from "./ExpohallarielBirdView.vue?vue&type=style&index=1&id=6de8c3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8c3b6",
  null
  
)

export default component.exports